import { handleSdkLoad } from "./handleSdkLoad";
import handleCookies from "./handleCookies";

export const loadSdk = async store => {
  window.OptanonWrapper = handleSdkLoad(store);
  handleCookies();
};
